import cx from 'classnames';
import React, { FC } from 'react';
import { FinancialStatus } from '../../schemas';
import styles from './FinancialStatusBadge.module.scss';

interface BadgeConf {
  styleColor: string;
  text: string;
}

const FINANCIAL_STATUSES: { [key in FinancialStatus]?: BadgeConf } = {
  [FinancialStatus.Paid]: {
    styleColor: 'Paid',
    text: 'Paid',
  },
  [FinancialStatus.Refunded]: {
    styleColor: 'Refunded',
    text: 'Refunded',
  },
  [FinancialStatus.PartiallyRefunded]: {
    styleColor: 'PartiallyRefunded',
    text: 'Partially Refunded',
  },
  [FinancialStatus.Pending]: {
    styleColor: 'NoInfo',
    text: 'Pending',
  },
};

const NO_INFO_STATUS: BadgeConf = {
  styleColor: 'NoInfo',
  text: 'No Info',
};

type Props = {
  className?: string;
  status: FinancialStatus | null;
};

const FinancialStatusBadge: FC<Props> = ({ className, status }: Props) => {
  if (!status) {
    return <span />;
  }

  const conf = FINANCIAL_STATUSES[status] || NO_INFO_STATUS;
  const styleColor = `status${conf.styleColor}`;
  const { text } = conf;

  return (
    <span
      className={cx(
        'rounded-pill text-center text-capitalize py-1 px-3',
        styles.statusText,
        styles[styleColor],
        className
      )}
    >
      {text}
    </span>
  );
};

export default FinancialStatusBadge;
